<template>
  <tab-content
    title="Upload Shapefile"
    :before-change="submit"
  >
    <b-form>
      <b-form-group
        label="Upload Shapefile"
        label-cols="3"
        label-size="lg"
        :disabled="loading"
      >
        <template slot="label">
          Upload Shapefile <HelpTooltip title="A .zip file containing .shp, .shx and .dbf files" />
        </template>
        <b-file
          v-model="shpFile"
          :state="Boolean(shpFile)"
          accept=".zip"
          placeholder="Choose a file..."
        />
      </b-form-group>
    </b-form>
  </tab-content>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

import HelpTooltip from '@/components/admin/upload/HelpTooltip.vue'
import { useUploadStore } from '@/store/admin/upload'

const components = {
  HelpTooltip,
}

const props = {
  loading: {
    type: Boolean,
    default: false,
  },
}

@Component({ components })
export default class UploadShp extends Vue.extend({ props }) {
  shpFile: Blob | null = null
  upload = useUploadStore()

  get geom () {
    return this.upload.geom
  }

  async submit () {
    try {
      if (this.shpFile) await this.upload.processShp(this.shpFile)
    } catch (e) {
      alert(e)
      console.log(e)
      return false
    }
    await this.upload.setShpLoaded(true)
    return true
  }
}

</script>
